export default __webpack_public_path__ + "static/media/content_tab02_01.65edaf26.png";